/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeatureeventstart3Inputs */

const en_aifeatureeventstart3 = /** @type {(inputs: Aifeatureeventstart3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event from a sentence, link or flyer`)
};

const de_aifeatureeventstart3 = /** @type {(inputs: Aifeatureeventstart3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung aus Satz, Link oder Flyer`)
};

/**
* | output |
* | --- |
* | "Event from a sentence, link or flyer" |
*
* @param {Aifeatureeventstart3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeatureeventstart3 = /** @type {((inputs?: Aifeatureeventstart3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeatureeventstart3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeatureeventstart3(inputs)
	return de_aifeatureeventstart3(inputs)
});
export { aifeatureeventstart3 as "aiFeatureEventStart" }